<template>
    <div>
        <div v-if="!isClubSelected">
            <SelectClubForSignup
                :favoritePlayerList="computedFavoritePlayerList"
                :selectedClubCodes="selectedClubCodes"
                :userinfo="userinfo"
                :step="step"
                @next="next"
                @back="back"
                :isXhr="isXhr"
                @club-selected="handleClubSelection"
            />
        </div>
        <div v-if="isClubSelected">
            <SelectFavoritePlayerForSignup
                :userinfo="userinfo"
                :selectedClubCode="selectedClubCode"
                :favoritePlayerList="computedFavoritePlayerList"
                :selectedClubCodes="selectedClubCodes"
                @change-view="handleViewChange"
            />
        </div>
    </div>
</template>

<script>
import SelectClubForSignup from './FavoritePlayer/SelectClubForSignup.vue'
import SelectFavoritePlayerForSignup from './FavoritePlayer/SelectFavoritePlayerForSignup.vue'
import { mixinJleague } from '../mixin/utility'

export default {
    name: 'FavoritePlayerForSignup',
    mixins: [mixinJleague],
    components: {
        SelectClubForSignup,
        SelectFavoritePlayerForSignup
    },
    data() {
        return {
            selectedClubCodes: [],
            showLoading: true,
            isClubSelected: false,
            selectedClubCode: null,
        }
    },
    props: {
        userinfo: {
            type: Object,
            required: true
        },
        step: {
            type: String,
            default: ''
        },
        isXhr: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        computedFavoritePlayerList() {
            return this.userinfo.favorite_player_list || [];
        }
    },
    methods: {
        handleClubSelection(clubCode) {
            this.selectedClubCode = clubCode;
            this.isClubSelected = true;
        },
        handleViewChange(view) {
            this.isClubSelected = view === 'SelectFavoritePlayer';
            if (!this.isClubSelected) {
                this.updateSelectedClubCodes();
            }
        },
        updateSelectedClubCodes() {
            if (this.userinfo && this.userinfo.favorite_player_list && this.userinfo.favorite_player_list.length > 0) {
                this.selectedClubCodes = this.userinfo.favorite_player_list.map(club => club.club_cd);
            }
        },
        next: function(){
            this.$emit('next', this.step, this.userinfo);
        },
        back: function(){
            this.$emit('back', this.step);
        },
    }
}
</script>
